import { PdsrStateType } from "./PdsrState/PdsrStateType";

export type PdsrEditItem = {
  ContainerNetwork: string;
  PlantGsdb: string;
  OutboundDock: string;
  SupplierGsdb: string;
  Comment: string;
  State: PdsrStateType;
};

export const pdsrEditItemDefaultValues = {
  ContainerNetwork: "",
  PlantGsdb: "",
  OutboundDock: "",
  SupplierGsdb: "",
  Comment: "",
  State: PdsrStateType.Expired,
};
